export default __webpack_public_path__ + "static/media/P5.ceedf1cd.png";